module.exports = __webpack_public_path__ + "static/img/adjust1.32eb4f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/adjust1.png
// module id = urJ1
// module chunks = 7